import React, { useState, useEffect } from "react"

const PopupButton = ({ dataPopup }) => {
  const [open, setOpen] = useState(false)

  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768)
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024)
    }

    handleResize()
    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  useEffect(() => {
    const popupClosed = sessionStorage.getItem("popupHomeClosed")

    if (popupClosed) {
      setOpen(false)
      return
    }

    setOpen(true)
  }, [])

  const onRedirect = () => {
    window.open(dataPopup?.redirect_url || process.env.NEXT_PUBLIC_EVENT_BUTTON, "_blank")
  }

  const handleClose = () => {
    setOpen(false)
    sessionStorage.setItem("popupHomeClosed", "true")
  }

  return (
    <>
      {open && (
        <div
          onClick={handleClose}
          className="w-screen h-screen bg-[#00000080] fixed top-0 left-0 z-50 flex items-center justify-center"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] lg:w-auto"
          >
            <img
              onClick={onRedirect}
              className="w-full h-full object-cover cursor-pointer"
              src={isMobile ? dataPopup?.vertical_img : dataPopup?.horizone_img}
              alt=""
            />

            <img
              onClick={handleClose}
              className="absolute -top-3 -right-3 lg:-top-6 lg:-right-6 cursor-pointer"
              width={isMobile ? 30 : isTablet ? 40 : 50}
              height={isMobile ? 30 : isTablet ? 40 : 50}
              src="/images/closeBtn.png"
              alt=""
            />
          </div>
        </div>
      )}
    </>
  )
}

export default PopupButton
